module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "edi-nav"
  }, [_vm._v("\n\t" + _vm._s(_vm.title) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8b9bfc6e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBar.vue
// module id = 601
// module chunks = 1